import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=6ad98a4c&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=ts&"
export * from "./Splash.vue?vue&type=script&lang=ts&"
import style0 from "./splash.scss?vue&type=style&index=0&id=6ad98a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad98a4c",
  null
  
)

export default component.exports